import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uploadLoading: false,
  uploadError: null,
  uploadHistory: [],
  uploadHistoryStatus: 'idle',
  uploadHistoryError: null,
  uploadProgressLoading: false,
  uploadProgressError: null,
};

const mileSlice = createSlice({
  name: 'mile',
  initialState,
  reducers: {
    uploadStart: (state) => {
      state.uploadError = null;
      state.uploadLoading = true;
    },
    uploadSuccess: (state) => {
      state.uploadError = null;
      state.uploadLoading = false;
    },
    uploadFailure: (state, action) => {
      state.uploadError = action.payload.message;
      state.uploadLoading = false;
    },
    uploadHistoryStart: (state) => {
      state.uploadHistory = [];
      state.uploadHistoryError = null;
      state.uploadHistoryStatus = 'loading';
    },
    uploadHistorySuccess: (state, action) => {
      state.uploadHistory = action.payload.data;
      state.uploadHistoryError = null;
      state.uploadHistoryStatus = 'success';
    },
    uploadHistoryFailure: (state, action) => {
      state.uploadHistoryError = action.payload.message;
      state.uploadHistoryStatus = 'fail';
      state.uploadHistory = [];
    },
    uploadProgressStart: (state) => {
      state.uploadProgressLoading = true;
      state.uploadProgressError = null;
    },
    uploadProgressSuccess: (state) => {
      state.uploadProgressLoading = false;
      state.uploadProgressError = null;
    },
    uploadProgressFailure: (state, action) => {
      state.uploadProgressLoading = false;
      state.uploadProgressError = action.payload.message || 'Failed to fetch upload progress';
    },
  },
});

export const {
  uploadStart,
  uploadSuccess,
  uploadFailure,
  uploadHistoryStart,
  uploadHistorySuccess,
  uploadHistoryFailure,
  uploadProgressStart,
  uploadProgressSuccess,
  uploadProgressFailure,
} = mileSlice.actions;

export default mileSlice.reducer;
